export default __webpack_public_path__ + "static/favicon-152-37f184aa3ca1907fc2692a2453daf0b8.png";